import {
  createDataObjectId,
  DataObjectId,
  Hub,
  MovementTemplate,
  movementTemplatesContainerId
} from 'yougile-model'
import {Sync} from '@client/sync'
import {globals} from '@extensions/globals-base'
import {refreshAfterMovementChanges} from './refresh-after-movement-changes'
import {RemoveAssignedOptions, SelectedPinStickers} from './types'

interface Props {
  boardId: DataObjectId
  title: string

  destinationProjectId: DataObjectId
  destinationBoardId: DataObjectId
  destinationColumnId: DataObjectId

  moveFromColumns: DataObjectId[]
  moveFromColumnsAllIn: boolean

  removeAssignedItem: RemoveAssignedOptions
  removeAssignedUsers: DataObjectId[]
  addNewAssigned: DataObjectId[]

  unsubscribeItem: RemoveAssignedOptions
  unsubscribeUsers: DataObjectId[]
  subscribeUsers: DataObjectId[]

  unpinStickers: DataObjectId[]
  pinStickers: SelectedPinStickers
}

export const createNewMovementTemplate = (props: Props): Hub => {
  const hub = getEmptyMovementTemplate()

  const id = hub.id
  const {boardId, title, moveFromColumns, moveFromColumnsAllIn} = props
  const {destinationProjectId, destinationBoardId, destinationColumnId} = props
  const {removeAssignedItem, removeAssignedUsers, addNewAssigned} = props
  const {unsubscribeItem, unsubscribeUsers, subscribeUsers} = props
  const {unpinStickers, pinStickers} = props

  const data: MovementTemplate = {
    id,
    boardId,
    title,

    destinationProjectId,
    destinationBoardId,
    destinationColumnId,
    moveFromColumns,

    enabled: true,
    moveFromColumnsAllIn,

    removeAssignedItem,
    removeAssignedUsers,
    addNewAssigned,

    unsubscribeItem,
    unsubscribeUsers,
    subscribeUsers,

    unpinStickers,
    pinStickers
  }
  hub.data.movementTemplate = data

  const box = Sync.getCurrentSandbox()
  box.add(hub, hub.location, true, false)
  refreshAfterMovementChanges(boardId)

  return hub
}

const getEmptyMovementTemplate = (): Hub => {
  const companyId = globals.getCompanyId()

  const hub = new Hub(companyId, '')
  hub.id = createDataObjectId()
  hub.title = hub.id
  hub.location = movementTemplatesContainerId

  return hub
}
